import React from "react"

const MOBILE_BREAKPOINT = 768

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<
    boolean | undefined
  >(undefined)

  React.useEffect(() => {
    const updateIsMobile = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
    }

    const mql = window.matchMedia(
      `(max-width: ${MOBILE_BREAKPOINT - 1}px)`
    )
    mql.addEventListener("change", updateIsMobile)

    // Set initial value
    updateIsMobile()

    return () =>
      mql.removeEventListener("change", updateIsMobile)
  }, [])

  // Default to false on the first render if undefined
  return isMobile === undefined ? false : isMobile
}
